import { gql } from '@apollo/client';
import { client } from 'client';
import normalizeVariables from 'graphql/schema/normalizeVariables';
import getClientMutationId from './getClientMutationId';

/**
 * @deprecated - This function should not be used, useQuery/useMutation are the primary method for performing queries/mutations.
 */
export default async function componentMutation(query, variables, noGql, onError = false) {
  variables = normalizeVariables(variables);
  if (!variables.clientMutationId) {
    variables.clientMutationId = getClientMutationId();
  }
  try {
    const response = await client.mutate({
      mutation: noGql
        ? query
        : gql`
            ${query}
          `,
      variables: { input: variables },
    });
    return { response: response.data, clientMutationId: variables.clientMutationId, errors: response.errors };
  } catch (e) {
    console.error('Mutation error', e);
    if (onError) return e;

    return {
      response: e?.networkError?.response,
      errors: e?.networkError?.result?.errors,
    };
  }
}
